export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FilterSinisters.vue?vue&type=template&id=f60f4414&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/extranet/FilterSinisters.vue?vue&type=template&id=f60f4414&scoped=true
// module id = 2074
// module chunks = 31